module.exports = __webpack_public_path__ + "static/media/UZ.ef2cba68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/UZ.svg
// module id = 2286
// module chunks = 7